var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "placeholder-selector-wrapper" }, [
    _c(
      "ul",
      { staticClass: "list-group" },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm._l(_vm.templateProductPlaceholders, function (tpPlaceholder, idx) {
          return _c(
            "li",
            {
              key: `tpPlaceholder-${idx}-${tpPlaceholder.epsId}`,
              staticClass:
                "list-group-item d-flex align-items-center justify-content-between",
              attrs: { id: `tpPlaceholder-${idx}-${tpPlaceholder.epsId}` },
            },
            [
              _c("span", [
                _vm._v(
                  "\n                " +
                    _vm._s(tpPlaceholder.epsName) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(_setup.CDropdown, {
                staticClass: "w-50",
                attrs: {
                  options: _setup.providerPlaceholders,
                  value: tpPlaceholder.providerPlaceholderId || "",
                  placeholder: "Select a placeholder",
                  name: "providerPlaceholder",
                },
                on: {
                  input: function ($event) {
                    return _setup.placeholderSelected($event, idx)
                  },
                },
              }),
            ],
            1
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "li",
      {
        staticClass:
          "list-group-item d-flex align-items-center justify-content-between",
      },
      [
        _c("span", [_c("strong", [_vm._v(" Page ")])]),
        _vm._v(" "),
        _c("span", { staticClass: "w-50" }, [
          _c("strong", [_vm._v(" POD Placeholder ")]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }